import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from './../../../../services/utils.service';
import { PaymentOptionType, Quote } from './../../../../models/quote.model';
import { Component, Input, OnInit } from '@angular/core';
import { ErrorResponse } from '../../../../models/error.model';
import { ConfirmDialogComponent } from '../../../../dialogs/confirm-dialog/confirm-dialog.component';
import { QuotesService } from 'src/app/services/quotes.service';

@Component({
    selector: 'app-quote-result',
    templateUrl: './quote-result.component.html',
    styleUrls: ['./quote-result.component.scss']
})
export class QuoteResultComponent implements OnInit {

    @Input()
    quote: Quote;

    constructor(
        public utilsService: UtilsService,
        private quotesService: QuotesService,
        private dialog: MatDialog,
    ) { }

    ngOnInit(): void {
    }

    sinPagoEfectivo = false;

    getOptionsByType(type: PaymentOptionType) {
        return this.quote?.opciones?.filter(option => option.tipo === type) ?? [];
    }

    // Efectivo se calcula con su propio coeficiente (calc_medio_pago clave "efectivo"),
    // ya no se deriva del monto de Transferencia.
    getEfectivoOptions() {
        return this.getOptionsByType('EFECTIVO');
    }

    downloadPdf() {
        this.quotesService.downloadPdf(this.quote.id).subscribe(response => {
            const blob = response.body;
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = response.headers.get('nombre-archivo') || `Cotizacion_${this.quote.id}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
        }, (error: ErrorResponse) => this.utilsService.alert('Error al generar PDF', 'No se pudo generar el PDF de la cotización.'));
    }

    openSendByEmailDialog() {
        const dialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                titulo: 'Enviar cotización por email',
                descripcion: 'Por favor ingrese el email al que desea enviarle el resultado de su cotización.',
                input: 'Email',
                botonCancelar: 'Cancelar',
                botonAceptar: 'Enviar'
            }
        });
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.quotesService.sendByEmail(this.quote.id, result).subscribe(_ => {
                    this.utilsService.alert('Email enviado correctamente', ``);
                }, (error: ErrorResponse) => this.utilsService.alert('Error al enviar email', error.error?.descripcion));
            }
        });
    }
}
